import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { EnterpriseModel } from 'src/app/models/management/enterprise.model';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-advanced-options-enterprise',
  templateUrl: './advanced-options-enterprise.component.html',
  styleUrls: ['./advanced-options-enterprise.component.scss'],
  standalone: false
})
export class AdvancedOptionsEnterpriseComponent implements OnInit {

  disabledForm: boolean = false;
  enterpriseContract: EnterpriseModel = new EnterpriseModel();
  permissionUpdatable: boolean = false;
  formEnterprise: FormGroup = new FormGroup({});
  suscription: Subscription;

  constructor(public config: DynamicDialogConfig,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm(this.enterpriseContract);
  }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.enterpriseContract = inputs.enterpriseContract;
      this.permissionUpdatable = inputs.permissionUpdatable;
      this.disabledForm = inputs.disabledForm;
      this.validateForm(this.enterpriseContract);
    });
  }

  async send() {
    this.validateFormControls();
    if (this.formEnterprise.valid) {
      const modelEnterprise = this.formEnterprise.getRawValue() as EnterpriseModel;
      if (modelEnterprise.invoiceObservation == "") modelEnterprise.invoiceObservation = null;
      if (modelEnterprise.invoiceObservation2 == "") modelEnterprise.invoiceObservation2 = null;
      if (modelEnterprise.invoiceObservation3 == "") modelEnterprise.invoiceObservation3 = null;
      if (modelEnterprise.invoiceObservationFooter == "") modelEnterprise.invoiceObservationFooter = null;
      if (modelEnterprise.invoiceText == "") modelEnterprise.invoiceText = null;
      if (modelEnterprise.invoiceText2 == "") modelEnterprise.invoiceText2 = null;
      if (modelEnterprise.invoiceText3 == "") modelEnterprise.invoiceText3 = null;
      if (modelEnterprise.invoiceText4 == "") modelEnterprise.invoiceText4 = null;
      if (modelEnterprise.invoiceText5 == "") modelEnterprise.invoiceText5 = null;
      if (modelEnterprise.invoiceText6 == "") modelEnterprise.invoiceText6 = null;
      if (modelEnterprise.discountAccount == "") modelEnterprise.discountAccount = null;
      if (modelEnterprise.utilizationAccount == "") modelEnterprise.utilizationAccount = null;
      if (modelEnterprise.refundAccount == "") modelEnterprise.refundAccount = null;
      if (modelEnterprise.interestAccount == "") modelEnterprise.interestAccount = null;
      if (modelEnterprise.commissionAccount == "") modelEnterprise.commissionAccount = null;

      this.enterpriseContract.invoiceObservation = modelEnterprise.invoiceObservation;
      this.enterpriseContract.invoiceObservation2 = modelEnterprise.invoiceObservation2;
      this.enterpriseContract.invoiceObservation3 = modelEnterprise.invoiceObservation3;
      this.enterpriseContract.invoiceObservationFooter = modelEnterprise.invoiceObservationFooter;
      this.enterpriseContract.invoiceText = modelEnterprise.invoiceText;
      this.enterpriseContract.invoiceText2 = modelEnterprise.invoiceText2;
      this.enterpriseContract.invoiceText3 = modelEnterprise.invoiceText3;
      this.enterpriseContract.invoiceText4 = modelEnterprise.invoiceText4;
      this.enterpriseContract.invoiceText5 = modelEnterprise.invoiceText5;
      this.enterpriseContract.invoiceText6 = modelEnterprise.invoiceText6;
      this.enterpriseContract.discountAccount = modelEnterprise.discountAccount;
      this.enterpriseContract.utilizationAccount = modelEnterprise.utilizationAccount;
      this.enterpriseContract.refundAccount = modelEnterprise.refundAccount;
      this.enterpriseContract.interestAccount = modelEnterprise.interestAccount;
      this.enterpriseContract.commissionAccount = modelEnterprise.commissionAccount;
      try {
        const response = await firstValueFrom(this.enterpriseService.updateEnterprise(this.enterpriseContract));
        this.enterpriseContract = response;
        this.validateForm(this.enterpriseContract);
        this.toastHandlerService.showToast('success', `La empresa fue modificada exitosamente.`);
      } catch (error) {
        console.error('Error al actualizar la empresa.', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      invoiceText: {
        maxlength: 'La Observación de Factura 1 no puede superar 100 caracteres.'
      },
      invoiceText2: {
        maxlength: 'La Observación de Factura 2 no puede superar 100 caracteres.'
      },
      invoiceText3: {
        maxlength: 'La Observación de Factura 3 no puede superar 100 caracteres.'
      },
      invoiceText4: {
        maxlength: 'La Observación de Factura 4 no puede superar 100 caracteres.'
      },
      invoiceText5: {
        maxlength: 'La Observación de Factura 5 no puede superar 100 caracteres.'
      },
      invoiceText6: {
        maxlength: 'La Observación de Factura 6 no puede superar 100 caracteres.'
      },
      swStoreInterface: {
        required: 'Debe indicar si usa Interfaz de Tienda.'
      },
      discountAccount: {
        maxlength: 'La Cuenta de Descuento no puede superar 20 caracteres.'
      },
      utilizationAccount: {
        maxlength: 'La Cuenta de Utilización no puede superar 20 caracteres.'
      },
      refundAccount: {
        maxlength: 'La Cuenta de Reintegro no puede superar 20 caracteres.'
      },
      interestAccount: {
        maxlength: 'La Cuenta de Intereses no puede superar 20 caracteres.'
      },
      commissionAccount: {
        maxlength: 'La Cuenta de Comisión no puede superar 20 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formEnterprise.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateFormState() {
    const shouldDisable = !this.permissionUpdatable || this.disabledForm;
    if (shouldDisable) {
      this.formEnterprise.disable();
    } else {
      this.formEnterprise.enable();
    }
  }

  validateForm(enterprise: EnterpriseModel) {
    this.formEnterprise = this.formBuilder.group({
      invoiceObservation: [enterprise.invoiceObservation,],
      invoiceObservation2: [enterprise.invoiceObservation2],
      invoiceObservation3: [enterprise.invoiceObservation3],
      invoiceObservationFooter: [enterprise.invoiceObservationFooter],
      invoiceText: [enterprise.invoiceText, [Validators.maxLength(100)]],
      invoiceText2: [enterprise.invoiceText2, [Validators.maxLength(100)]],
      invoiceText3: [enterprise.invoiceText3, [Validators.maxLength(100)]],
      invoiceText4: [enterprise.invoiceText4, [Validators.maxLength(100)]],
      invoiceText5: [enterprise.invoiceText5, [Validators.maxLength(100)]],
      invoiceText6: [enterprise.invoiceText6, [Validators.maxLength(100)]],
      swStoreInterface: [enterprise.swStoreInterface, [Validators.required]],
      discountAccount: [enterprise.discountAccount, [Validators.maxLength(20)]],
      utilizationAccount: [enterprise.utilizationAccount, [Validators.maxLength(20)]],
      refundAccount: [enterprise.refundAccount, [Validators.maxLength(20)]],
      interestAccount: [enterprise.interestAccount, [Validators.maxLength(20)]],
      commissionAccount: [enterprise.commissionAccount, [Validators.maxLength(20)]]
    });
    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formEnterprise.controls).forEach((key) => {
      const control = this.formEnterprise.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
